<div class="al-continuar-tus-datos-sern-parent">
  <div class="al-continuar-tus">
    <span [innerHTML]="'first-information-layer' | translate"></span>
  </div>
</div>
